import { render, staticRenderFns } from "./checkTransferVerifyCode.vue?vue&type=template&id=50524407&scoped=true&"
import script from "./checkTransferVerifyCode.vue?vue&type=script&lang=js&"
export * from "./checkTransferVerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./checkTransferVerifyCode.vue?vue&type=style&index=0&id=50524407&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50524407",
  null
  
)

export default component.exports